<template>
  <component
    v-if="src"
    v-bind="$attrs"
    :src="src"
    :is="is"
    ref="media"
    onerror="this.failed = true"
    @error="error"
    onload="this.loaded = true"
    @load="load"
  />
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    source: { type: [Array, String], required: true },
    is: { type: String, required: true },
  },
  data() {
    return {
      fallback: 0,
    };
  },
  computed: {
    src() {
      if (Array.isArray(this.source)) {
        return this.source[this.fallback % this.source.length];
      }
      return this.source;
    },
  },
  mounted() {
    if (this.$refs.media?.failed) {
      this.error();
    }

    if (this.$refs.media?.loaded) {
      this.load();
    }
  },
  methods: {
    error() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.fallback++;
      }, 2000);
    },
    load() {
      this.$emit('load', this.src);
    },
  },
  beforeUnmount() {
    clearTimeout(this.timeout);
  },
});
</script>
